import { api } from './api';
export interface EmailBrandingConfig {
  enabled: boolean;
  brand_name: string;
  logo_url: string;
  accent_color: string;
  website_url: string;
  footer: string;
}
export interface EmailBranding { config: EmailBrandingConfig; revision: number }
export const AdminEmailBrandingAPI = {
  get: async () => (await api.get<EmailBranding>('/api/admin/email-branding/')).data,
  save: async (data: EmailBranding) => (await api.put<EmailBranding>('/api/admin/email-branding/', data)).data,
  preview: async (body: string, body_html: string, include_signature = false, config?: EmailBrandingConfig) =>
    (await api.post<{ body_html: string }>('/api/admin/email-preview/', { body, body_html, include_signature, ...(config ? { config } : {}) })).data,
};
